var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import loginDi from "@frameworks/salesjourney/components/Login/di/index";
import { useSelector } from "react-redux";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
var ProfilePopup = function (props) {
    var _a;
    var navigate = useNavigate();
    var _b = __read(React.useState((_a = props.desk) !== null && _a !== void 0 ? _a : null), 2), desk = _b[0], setDesk = _b[1];
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.onDeskDetails;
    });
    var profileMainData = useSelector(function (state) { return state.Profile.ProfileDetails.reducersData.data; });
    var getOnDeskInformation = function () {
        profileDI.profile.getONDeskDetails();
    };
    var updateOnDeskDetails = function (desk) {
        setDesk(!desk);
        var reqObj = {
            isOnDesk: !desk,
        };
        profileDI.profile.updateOnDeskDetails(reqObj).then(function (onDeskResponse) {
            if (onDeskResponse) {
                getOnDeskInformation();
            }
        });
    };
    //logoutUserFun shifted to Index.tsx
    var redirectToFPDPortal = function () {
        loginDi.login.redirectionToFPDUrl().then(function (resp) {
            window.open(resp === null || resp === void 0 ? void 0 : resp.url, "_blank");
        });
    };
    var redirectTo360View = function () {
        var _a, _b, _c, _d, _e, _f;
        var clientSearchData = {
            clientName: (_a = profileMainData === null || profileMainData === void 0 ? void 0 : profileMainData.profileDetails) === null || _a === void 0 ? void 0 : _a.empName,
            userName: "",
            accountCode: (_b = profileMainData === null || profileMainData === void 0 ? void 0 : profileMainData.profileDetails) === null || _b === void 0 ? void 0 : _b.empcodetxt,
            udnNo: "",
            leadId: "",
            pan: "",
            priority: "",
            msgFlag: "",
            accessMsg: "",
            mobileNo: "",
            email: "",
            isPartner: true,
            uniqueCode: "",
            upcId: (_d = (_c = profileMainData === null || profileMainData === void 0 ? void 0 : profileMainData.profileDetails) === null || _c === void 0 ? void 0 : _c.userId) === null || _d === void 0 ? void 0 : _d.toString(),
            fromProfileRedirection: true,
        };
        var searchActionPayload = {
            upcId: (_f = (_e = profileMainData === null || profileMainData === void 0 ? void 0 : profileMainData.profileDetails) === null || _e === void 0 ? void 0 : _e.userId) === null || _f === void 0 ? void 0 : _f.toString(),
            page: 1,
            pageSize: 100,
        };
        clientDi.clients.clearSelectedClientData();
        clientDi.partnerOverview.getPartnerSearchAction(searchActionPayload, clientSearchData);
        navigate("/clientdetails/overview?link=".concat("profile"));
    };
    React.useEffect(function () {
        if (profileData !== null) {
            setDesk(profileData);
            //  props.setDesk(desk);
        }
    }, [profileData, props.isOnDesk]);
    var redirectToProductFAQ = function () {
        window.open(URLConfig.config.productFAQLink, "_blank");
    };
    var generateSupportTooltip = function (isCollapsedSidebar) {
        return (React.createElement(GenericPopup, { isHeadline: true, parentClass: "sidebar-tooltip support-sidebar-tooltip", placement: "right-end", children: React.createElement(React.Fragment, null, "Client Support 18001023335"), button: React.createElement("div", { className: "footer-links" }, !isCollapsedSidebar && (React.createElement("span", { className: " txt-midnight-blue" }, "Support"))) }));
    };
    return (React.createElement(React.Fragment, null,
        !(props === null || props === void 0 ? void 0 : props.client360) && !loginDI.login.getIsRMPartnerFRM().isPartner && (React.createElement("div", { className: "desk-on-off-toggle" },
            React.createElement("label", { className: "toggle" },
                React.createElement("input", { type: "checkbox", className: "d-none", checked: !desk }),
                React.createElement("span", { className: "slider" }),
                React.createElement("label", null),
                React.createElement("span", { onClick: function () { return updateOnDeskDetails(desk); }, className: "labels ".concat(!desk ? "active" : ""), "data-on": "On Desk", "data-off": "Off Desk" })))),
        !(props === null || props === void 0 ? void 0 : props.client360) && !loginDI.login.getIsRMPartnerFRM().isPartner && (React.createElement("div", { className: "desk-period d-flex align-items-center" },
            React.createElement(EdButton, { value: "Set Off Desk Period", type: "button", btnTyp: "midnight-blue-underline", className: "desk-period-button", onClick: function () {
                    props === null || props === void 0 ? void 0 : props.setShowDeskPeriodPopup(true);
                    props === null || props === void 0 ? void 0 : props.setProfilePopup(false);
                } }),
            React.createElement("i", { className: "edel-icon-arrow-right1 " }))),
        React.createElement("div", { className: "DMSansNormal_12_400 txt_dark_secondary-gray hand_cursor px-3 py-2 support-tag" },
            "Support",
            React.createElement("div", { className: "d-flex align-items-center mt-1 txt-midnight-blue DMSansNormal_12_400" },
                React.createElement("i", { className: "edel-icon-phone1 me-1" }),
                "18001023335")),
        React.createElement("div", { className: "p-3 ".concat(props.client360 ? "profileClient360" : null) },
            React.createElement(Link, { to: "/dashboard/profile", onClick: function () { return props.setProfilePopup(false); } },
                React.createElement("div", { className: "DMSansNormal_12_400 txt-midnight-blue hand_cursor pb-2" }, "My Profile")),
            !loginDI.login.getIsRMPartnerFRM().isPartner && (React.createElement("div", { className: "DMSansNormal_12_400 txt-midnight-blue hand_cursor pb-2", onClick: function () {
                    redirectToProductFAQ();
                } }, "Product FAQ's")),
            loginDI.login.getIsRMPartnerFRM().isPartner && (React.createElement("div", { className: "DMSansNormal_12_400 txt-midnight-blue hand_cursor pb-2", onClick: function () {
                    props.setChangePasswordPopup(true);
                    props.setProfilePopup(false);
                } }, "Change Password")),
            loginDI.login.getIsRMPartnerFRM().isPartner && (React.createElement("div", { className: "DMSansNormal_12_400 txt-midnight-blue hand_cursor pb-2", onClick: function () {
                    redirectTo360View();
                } }, "My 360")),
            React.createElement("div", { className: "DMSansNormal_12_400 txt-midnight-blue hand_cursor pb-2", onClick: function () {
                    navigate("/dashboard/downloads");
                    // navigate("/dashboard/downloads", {
                    //   state: { showToday: DownloadTimeCategory.TODAY },
                    // });
                } }, "My Downloads"),
            React.createElement("div", { onClick: function () {
                    props === null || props === void 0 ? void 0 : props.logoutUser();
                }, className: "DMSansNormal_12_400 txt_bloodRed hand_cursor pb-2" }, "Logout"))));
};
export default ProfilePopup;
